export enum SortDirection {
  ASC,
  DES,
}
